import { Languages } from "../../types";
import { createExpenditureRecordDictionary } from "./CreateExpenditureRecord";
import { expenditureRecordsDictionary } from "./ExpenditureRecords";
import { AccountPayablesPagesDescriptions } from "./types";

export const getAccountPayablesDescriptions = (systemLang: Languages): AccountPayablesPagesDescriptions => ({
    EXPENDITURE_RECORDS: expenditureRecordsDictionary[systemLang],
    CREATE_EXPENDITURE_RECORD: createExpenditureRecordDictionary[systemLang],
})